<template>
    <button id="TVPOWER" name="TVPOWER" class="btn" data-vcode="POWER" disabled :aria-label="`${$t('tvPower')}`">
        <img src="/images/icons/tvPower.svg" alt="" />
        <label aria-hidden="true">{{ $t('tvPower') }}</label>
    </button>
</template>
<script>
export default {};
</script>
